import React from 'react';
import PropTypes from 'prop-types';

import FormLabel from 'components/FormLabel/FormLabel';

import { StyledFormItem } from './FormItem.styles';

const addRules = (requiredErrorMessage, extraRules) => {
  const rules = [];

  if (!!requiredErrorMessage) {
    rules.push({
      required: true,
      message: requiredErrorMessage
    });
  }

  return [...rules, ...extraRules];
};

const FormItem = ({ name, label, requiredErrorMessage, extraRules, children, defaultValue, normalize }) => {
  const rules = addRules(requiredErrorMessage, extraRules);

  return (
    <>
      {!!label && <FormLabel hasRequiredErrorMessage={!!requiredErrorMessage}>{label}</FormLabel>}
      <StyledFormItem name={name} colon={false} rules={rules} initialValue={defaultValue} normalize={normalize}>
        {children}
      </StyledFormItem>
    </>
  );
};

FormItem.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  defaultValue: PropTypes.any,
  extraRules: PropTypes.array,
  label: PropTypes.string,
  requiredErrorMessage: PropTypes.string
};

FormItem.defaultProps = {
  label: '',
  requiredErrorMessage: '',
  extraRules: []
};

export default FormItem;
